export class EmploymentProcessingService {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    constructor($http, Upload, apexApiUrl) {
        'ngInject'
        this.$http = $http
        this.Upload = Upload
        this.apexApiUrl = apexApiUrl
    }

    retrieveNewHires() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "employments/new-hires",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Process the new hire with the given employee ID
     * @param {Number} employeeID The employee's ID.
     * @param {{ EmployeeID: number, ADPEmployeeID: Number, SSN: string, FEIN: string }} request The request data.
     * @returns {Promise} The response.
     */
    processNewHire(employeeID, request) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "employments/new-hires/" + employeeID,
            data: request,
            headers: { "Content-Type": "application/json" }
        });
    }

    /**
    * Process the change requests with the given employee id
    * @param {Number} employeeID The employee's ID.
    * @param {{ EmployeeID: number, ADPEmployeeID: Number, SSN: string, FEIN: string }} request The request data.
    * @returns {Promise} The response.
    */
    processChangeRequests(employeeID, changehistoryID) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "employments/changehistory/" + employeeID + "/" + changehistoryID,
            headers: { "Content-Type": "application/json" }
        });
    }

    /**
    * Process the change requests with the given employee id
    * @returns {Promise} The response.
    */
    processChangeRequestsBatch(items) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "employments/changehistory/batch",
            headers: { "Content-Type": "application/json" },
            data: items
        });
    }
    /**
     * Get the list of terminations that can be processed by the current user.
     * @returns {Promise<any>} The list of terminations.
     */
    retrieveTerminations() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "employments/terminations",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    processTermination(employeeID) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "employments/terminations/" + employeeID,
            headers: { "Content-Type": "application/json" }
        });
    }

    processDirectDeposit(employeeID, ddID) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "employments/direct-deposit/" + employeeID + "/" + ddID,
            headers: { "Content-Type": "application/json" }
        });
    }

    parseNewHiresDataFromFile(file) {
        return this.Upload.upload({
            url: this.apexApiUrl + "/payrolls/read-adp-emp-numbers-from-excel",
            data: { adpImportNumbers: file }
        }).then(function (response) {
            return response.data;
        });
    }

    parseTerminationsDataFromFile(file) {
        return this.Upload.upload({
            url: this.apexApiUrl + "/payrolls/read-termination-emp-numbers-from-excel",
            data: { adpImportNumbers: file }
        }).then(function (response) {
            return response.data;
        });
    }

    parseDirectDepositDataFromFile(file) {
        return this.Upload.upload({
            url: this.apexApiUrl + "/payrolls/read-direct-deposit-from-excel",
            data: { ddImportNumbers: file }
        }).then(function (response) {
            return response.data;
        });
    }

    parseEmployeeChangeRequestDataFromFile(file) {
        return this.Upload.upload({
            url: this.apexApiUrl + "/payrolls/read-req-numbers-from-excel",
            data: { changeHistoryNumbers: file }
        }).then(function (response) {
            return response.data;
        });
    }

    finishNewAdpNumbersImport(uploadedNumbers) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "/payrolls/import-adp-emp-numbers-to-apex",
            data: JSON.stringify(uploadedNumbers),
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    finishTerminationsImport(employees) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "/payrolls/process-terminated-employees",
            data: JSON.stringify(employees),
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }
}
